<!-- eslint-disable max-len -->

<template>
  <!-- Recolor by luckydonald -->
  <!-- Original: https://www.deviantart.com/king-koder/art/ATG-Day1-Reflection-497883053 -->
  <!-- Original (SVG): https://www.deviantart.com/em120x/art/Littlepip-king-koder-style-vector-499037570
https://sta.sh/0zk8ver1zys -->
  <!-- Original (SVG): https://sta.sh/0zk8ver1zys -->
  <!-- File: ~/Documents/Projects/PipBuck 3000/graphics/stats pony/littlepip_outlines.wrong_color.with_health.versionC.scale1.optim.svg -->
<svg viewBox="-86 2 356 304" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g class="pony" transform="translate(-70.003577 -75.230404)">
        <path d="m167.625 127.187c2.982 22.525 3.758 45.339-5.969 67.188-1.525-1.858-3.036-3.942-4.438-6.656l-1.406-2.688-1.281 2.75c-.508 1.09-.938 1.654-1.375 2.312-.002-2.701.062-5.316.938-7.781l-1.25-.188c-1.626 4.584-1.66 7.96-1.844 11.938l-.125 3.688 1.781-2.375c.943-.93 2.057-2.238 3.219-4.062 1.615 2.728 3.324 5.087 5.094 6.969l1.5 1.594.938-1.969c11.199-23.317 10.298-47.636 7.188-71.125z" :fill="mane"/>
        <path d="m87.942 143.853c-.231-.264-1.335-.464-2.162-.464-.793 0-1.938.12-2.21.377-1.135 1.074-1.754 3.106-1.754 5.336 0 2.294.738 4.306 1.847 5.433.054.055.537.202 1.03.269.536.073.704.043 1.025.048.999.014 2.25-.505 2.293-.583.732-1.311 1.605-3.043 1.605-5.167.001-2.174-.661-4.095-1.674-5.249zm.87 5.094c-.002 2.816-1.343 5.097-2.995 5.094-1.651-.003-2.989-2.288-2.988-5.104 0-.003 0-.007 0-.01.001-2.816 1.343-5.097 2.995-5.094.374 0 .728.132 1.058.347.512.071 1.082.381 1.534.889.756.849.893 1.916.305 2.382-.014.011-.032.017-.046.027.082.465.139.948.138 1.458-.001.004-.001.008-.001.011z" :fill="eyes" fill-opacity=".8"/>
        <g :fill="white">
          <path d="m83.57 143.766c.241-.227 1.161-.347 1.919-.372l.001-.009c-1.922-1.002-3.965-1.276-6.219-.281l.438 11.812 3.715-.66c-.972-1.162-1.608-3.033-1.608-5.154 0-2.23.619-4.263 1.754-5.336z"/>
          <path d="m85.985 144.376c.587-.467 1.675-.156 2.431.693s.893 1.916.305 2.382c-.586.466-1.675.156-2.43-.693-.756-.849-.893-1.916-.306-2.382z"/>
          <path d="m85.306 147.245c.215-.17.612-.057.889.253.275.311.326.701.111.871-.215.171-.612.057-.889-.253s-.326-.7-.111-.871z"/>
        </g>
        <path d="m79.24 143.916c4.619-.787 6.033.035 10.75 3.719-.189-4.386-8.854-9.623-10.75-3.719z" :fill="body"/>
        <path d="m199.425 292.107c-1.428 46.904-6.051 44.112-5.23 58.211.021 4.969 5.861 7.262 10.627 7.595 4.303.302 10.574.16 14.646-1.457"
              fill="none" :stroke="body" stroke-width="3"/>
        <path d="m173.99 251.603c-4.363 23.917 18.876 40.696 29.188 44.531v.031c1.455.825 3.713 4.477 5.438 8.75 1.724 4.273 3.172 9.096 4.125 12.406 4.761 16.549 5.166 32.048 5.75 49.719.061 1.849 1.16 3.373 2.562 4.375s3.141 1.634 5 2.094c3.719.92 7.928 1.118 10.781 1.031 2.72-.083 6.639-.478 10.125-1.531 1.742-.527 3.391-1.203 4.75-2.188 1.358-.984 2.459-2.348 2.781-4.062v-.062-.094c1.789-20.834.524-39.883-4.812-56.562-2.451-7.656-6.391-16.647-11.062-23.875-2.336-3.613-4.836-6.772-7.5-9.125-2.665-2.353-5.539-3.947-8.562-4.062h-.031c-1.142.011-8.474.209-8.375 7.281 1.457-2.444 3.205-4.316 8.312-4.281h.031c2.022.087 4.277 1.24 6.625 3.312 2.357 2.082 4.764 5.072 7 8.531 4.472 6.918 8.346 15.742 10.719 23.156 5.163 16.137 6.432 34.724 4.688 55.219-.148.789-.644 1.499-1.594 2.188-.951.688-2.307 1.285-3.844 1.75-3.075.93-6.83 1.33-9.344 1.406-2.627.08-6.693-.127-9.969-.938-1.639-.405-3.09-.975-4-1.625-.912-.65-1.255-1.231-1.281-2.031-.584-17.656-.989-33.454-5.875-50.438-.959-3.331-2.417-8.252-4.219-12.719-1.803-4.467-3.693-8.533-6.719-10.25l-.031-.031h-.031c-20.613-10.257-30.394-24.897-30.626-41.906z"
              :fill="body"/>
        <path d="m215.49 276.322 2.438-1.75c-7.617-10.476-7.339-21.287-6.094-32.125-5.799 18.843.754 29.092 3.656 33.875z"
              :fill="body"/>
        <path d="m139.052 268.876c11.653 3.126 24.423 4.82 38.765 3.283" fill="none" :stroke="body" stroke-width="3"/>
        <path d="m123.754 270.742c-1.269 32.186-8.541 55.543-17.857 75.893-2.471 7.597 8.84 8.492 14.46 9.139 5.922.68 18.377-.024 20.361-5.924 7.323-25.217 8.849-51.306 8.681-78.701"
              fill="none" :stroke="body" stroke-width="3"/>
        <path d="m213.574 220.474c8.164 10.159 7.352 26.43 3.036 41.25-1.298 6.738 11.522 6.657 9.911 14.018"
              fill="none" :stroke="body" stroke-width="3"/>
        <path d="m150.521 199.197c.865 5.612 3.209 10.831 8.406 13.656l.031.031.062.031c8.719 4.078 16.011 3.176 23.031 2.156s13.793-2.156 22.438 1l1.031-2.812c-9.342-3.411-16.893-2.17-23.875-1.156-6.955 1.01-13.33 1.812-21.281-1.875-4.178-2.271-6.121-6.4-6.906-11.5-.787-5.1.42-13.169.995-18.361l-3.581 3.036c-.396 5.207-1.016 9.845-.351 15.794z"
              :fill="body"/>
        <path d="m108.117 239.329c-1.4-15.655-.723-36.013 4.739-49.039" fill="none" :stroke="body" stroke-width="3"/>
        <g :fill="body">
            <path d="m79.677 154.166c-1.676.206-3.205.337-4.531 1.312-1.328.976-1.887 2.734-1.812 4.969v.062.094c1.449 11.717 8.784 20.185 18.406 25.344 2.89 1.5 19.305 8.627 32.406 3.156-10.586.945-22.014-.994-31-5.812-8.951-4.799-15.455-12.327-16.812-22.938-.059-1.771.198-2.178.594-2.469.395-.29 1.479-.517 3.125-.719 4.264-.766 10.439-2.194 13.495-8.027-2.99 2.325-7.666 3.758-13.871 5.028z"/>
            <path d="m207.516 221.809c2.165 2.699 3.087 7.701 3.558 10.419 1.879-5.145-.455-8.937-1.727-11.402z"/>
            <path class="mouth happy"        v-if="face === 'happy'"        d="m91.315 176.534c1.392 5.347 10.104 2.012 11.761-1.65-3.348 2.137-7.149 3.427-11.761 1.65z"/>
            <path class="mouth cat"          v-if="face === 'cat'"          d="m88.254 172.522c-.735 6.786 2.587 5.23 5.019 4.297 1.329 1.385 8.766 2.771 9.388-3.732-3.408 4.443-7.515 3.126-9.267 1.092-1.586 1.214-2.878 3.433-5.14-1.657z"/>
            <path class="mouth cat-smirk"    v-if="face === 'cat-smirk'"    d="m100.973 172.058c.574.271 1.001.761 1.32 1.313-.072.085-.142.178-.214.258-3.294 3.668-7.075 2.384-8.737.454-1.585 1.214-2.877 3.433-5.14-1.657-.735 6.786 2.587 5.23 5.019 4.297 1.219 1.271 7.778 1.626 9.545-2.275.225.688.321 1.337.321 1.688 1.234-1.593-.643-4.726-2.114-4.078z"/>
            <path class="mouth sad"          v-if="face === 'sad'"          d="m91.315 178.677c1.392-5.347 10.376-2.884 11.761 1.65-3.947-2.597-8.26-3.909-11.761-1.65z"/>
            <path class="mouth meh negative" v-if="face === 'meh-negative'" d="m91.815 178.677c2.855-1.946 10.355-1.113 12.688 1.054-3.499-.667-8.166-1.167-12.688-1.054z"/>
            <path class="mouth meh neutral"  v-if="face === 'meh-neutral'"  d="m91.399 177.702c2.021.862 9.663.917 13.646.154-1.958-.792-9.958-1.042-13.646-.154z"/>
            <path class="mouth meh positive" v-if="face === 'meh-positive'" d="m91.399 177.702c2.564 2.316 10.108 2.51 12.714.681-3.559.184-8.25.045-12.714-.681z"/>

            <path d="m156.427 89.072h-.031-.062c-1.6.101-2.859 1.039-4.188 2.25s-2.668 2.806-3.938 4.562c-2.54 3.514-4.803 7.644-5.781 10.938-1.83 4.351-2.547 13.953 3.156 21.625-1.645-7.336-2.192-14.323-.281-20.75.807-2.716 2.945-6.789 5.312-10.062 1.183-1.637 2.431-3.09 3.531-4.094 1.083-.988 2.057-1.407 2.344-1.438.264.02 1.437.412 2.781 1.438 1.373 1.048 2.977 2.638 4.469 4.594 2.983 3.912 5.578 9.311 5.781 15.25.287 8.391-.468 10.854-5.875 22.625l-.188.438.062.438c1.967 11.268 1.566 20.547-.844 28.094-2.733 8.556-7.998 14.938-15.594 19.656 10.666-2.472 16.618-13.25 18.438-18.75 2.561-8.017 2.963-17.633 1.031-29.031 5.244-11.452 6.26-15.06 5.969-23.562-.23-6.738-3.123-12.695-6.406-17-1.643-2.152-3.398-3.879-5.031-5.125s-3.057-2.085-4.655-2.096z"/>
            <path d="m85.675 161.6c.256 2.064.162 2.858-1.95 3.417 3.855 1.051 4.115-2.002 1.95-3.417z"/>
            <path d="m143.552 259.353c-.698 2.305-1.737 5.043-3.688 7.156s-4.771 3.715-9.594 3.719c-7.93.09-17.636-6.516-26.699-10.002l.105 2.971c8.436 3.244 17.128 10.123 26.594 10.031h.031c5.498-.014 9.326-2.029 11.781-4.688 1.681-1.868 2.933-5.927 1.47-9.187z"/>
            <path d="m90.99 235.103c-3.873 1.093-7.052 3.697-9.406 7.594-2.355 3.896-3.95 9.08-4.875 15.625l2.969.406c.889-6.288 2.418-11.108 4.469-14.5 2.049-3.392 4.539-5.371 7.656-6.25 6.234-1.759 17.205 1.411 29.204 9.283-7.646-9.492-17.493-12.249-23.798-12.752-2.21-.15-4.284.048-6.219.594z"/>
        </g>
        <path d="m78.948 282.103c.927 16.224 7.295 26.294 16.429 27.678 5.643 1.561 15.219-12.28 15.625-23.214.176-6.482-5.612-8.458-8.217-9.917"
              fill="none" :stroke="body" stroke-width="3"/>
        <path d="m310.147 335.293c-18.542 3.898-37.904-6.852-46.2-22.859-4.508-8.697-5.959-21.002-2.793-38.76-2.543 2.087-6.322 2.729-9.848 2.525 3.889-11.422 5.811-21.203 5.705-29.289-.186-14.103-7.924-25.301-20.984-29.175-3.807-1.129-12.715-1.8-17.585.225-2.464 1.023-4.499 2.151-6.317 2.833-2.295.86-3.488 2.083-6.275-.656-1.687-1.829-.791-4.208 1.432-6.653 3.957-4.353 12.117-8.911 17.391-10.923 8.191-3.127 17.189-3.998 23.609-3.903 15.712.232 32.403 6.403 43.936 19.207-3.248.114-4.564.217-6.944.758 11.827 16.105 16.106 29.522 16.839 41.192 1.15 18.327-6.445 32.344-7.277 45.687-.614 9.81 2.435 19.26 15.311 29.791z"
              fill="none" :stroke="mane" stroke-width="3"/>
        <path d="m80.539 133.063c-1.836 7.5-2.557 15-.715 22.5" fill="none" :stroke="body" stroke-width="3"/>
        <path class="pipboy screen" d="m76.36 263.889c-1.396 3.996.201 8.741 1.389 13.385l4.925-.632c.156-4.501.889-9.11-1.516-13.132z" :fill="eyes" fill-opacity=".8"/>
        <path d="m104.824 262.17c-9.506-5.578-19.184-5.817-29.643-2.231-.727.144-1.777 5.104 5.09 3.438 3.061-.304 3.512 13.765.982 13.481-5.923-.023-7.28 5.812-3.93 5.581 4.416-.374 10.467-3.234 15.305-4.022 5.984-.975 9.916-.732 11.125-1.647 2.154-1.196 2.289-4.606 2.331-7.858.043-3.256-.008-6.352-1.26-6.742z"
              fill="none" :stroke="body" stroke-width="2.5"/>
        <path d="m76.297 263.636c-.021 4.541-.633 9.13 1.516 13.89" fill="none" :stroke="body" stroke-width="2"/>
        <path d="m86.722 272.208c.002-1.098.893-1.985 1.99-1.983s1.984.894 1.982 1.99v.008c-.002 1.098-.893 1.984-1.99 1.982s-1.985-.893-1.982-1.99c0-.002 0-.005 0-.007z"
              :fill="body"/>
        <path d="m86.61 264.864c.002-1.098.894-1.985 1.99-1.983s1.985.894 1.983 1.99v.008c-.002 1.098-.894 1.984-1.99 1.982-1.098-.002-1.985-.893-1.983-1.99 0-.002 0-.005 0-.007z"
              :fill="body"/>
        <!--
        <path d="m124.325 141.946c-.491-.593-2.831-1.041-4.584-1.041-1.682 0-4.108.269-4.685.846-2.408 2.408-3.72 6.967-3.72 11.968 0 5.145 1.564 9.657 3.915 12.185.115.124 1.139.453 2.184.604 1.137.164 1.493.098 2.174.107 2.119.031 4.772-1.133 4.864-1.307 1.55-2.94 3.404-6.827 3.404-11.589.001-4.877-1.405-9.185-3.552-11.773zm1.47 11.404v.023c-.004 6.316-2.763 11.432-6.162 11.425-3.4-.006-6.152-5.132-6.149-11.448 0-.008 0-.016 0-.023.003-6.316 2.763-11.432 6.161-11.425.765.001 1.493.273 2.168.748 1.149.074 2.48.79 3.518 2.024 1.602 1.905 1.891 4.298.646 5.344-.125.105-.268.18-.413.251.147.981.231 2.011.231 3.081z"
              :fill="eyes"/>
        <path d="m125.564 150.268c-1.295.631-3.301-.092-4.742-1.805-1.602-1.905-1.892-4.298-.646-5.345.438-.369 1.012-.51 1.637-.47-.675-.474-1.403-.746-2.168-.748-3.398-.006-6.158 5.109-6.161 11.425v.023c-.003 6.316 2.749 11.442 6.149 11.448 3.399.006 6.158-5.109 6.162-11.425 0-.008 0-.016 0-.023 0-1.068-.084-2.098-.231-3.08zm-4.707 1.809c-.455.383-1.299.128-1.885-.568s-.691-1.571-.236-1.954 1.299-.128 1.885.568c.585.696.691 1.571.236 1.954z"
              :fill="body"/>
        -->
        <path d="m124.325 141.946c-.491-.593-2.831-1.041-4.584-1.041-1.682 0-4.108.269-4.685.846-2.408 2.408-3.72 6.967-3.72 11.968 0 5.145 1.564 9.657 3.915 12.185.115.124 1.139.453 2.184.604 1.137.164 1.493.098 2.174.107 2.119.031 4.772-1.133 4.864-1.307 1.55-2.94 3.404-6.827 3.404-11.589.001-4.877-1.405-9.185-3.552-11.773zm-4.693 22.852c-3.4-.006-6.152-5.132-6.149-11.448 0-.008 0-.016 0-.023.003-6.316 2.763-11.432 6.161-11.425 3.4.006 6.153 5.132 6.15 11.449v.023c-.003 6.315-2.762 11.43-6.162 11.424z" :fill="eyes" fill-opacity=".8"/>
        <g :fill="white">
            <path d="m119.609 166.615c1.019.015 2.159-.247 3.081-.542-1.122.342-2.31.53-3.542.53-1.245 0-2.446-.194-3.579-.547.403.149 1.126.345 1.866.451 1.137.164 1.493.098 2.174.108z"/>
            <path d="m119.741 140.905c-1.682 0-4.108.269-4.685.846-.253.253-.488.543-.717.842 1.478-.636 3.103-.989 4.809-.989 2.218 0 4.294.603 6.092 1.644-.289-.466-.59-.91-.915-1.301-.491-.594-2.831-1.042-4.584-1.042z"/>
            <path d="m118.736 149.555c-.455.382-.35 1.257.236 1.954s1.43.951 1.885.569c.455-.382.349-1.257-.236-1.954-.586-.698-1.43-.952-1.885-.569z"/>
            <path d="m125.564 150.268c.145-.071.288-.146.413-.251 1.244-1.046.955-3.439-.646-5.344-1.038-1.234-2.368-1.95-3.518-2.024-.625-.04-1.199.101-1.637.47-1.245 1.047-.955 3.439.646 5.345 1.44 1.712 3.446 2.435 4.742 1.804z"/>
            <path d="m124.073 165.54c-.177.079-.353.161-.534.231.213-.084.387-.161.534-.231z"/>
            <path d="m125.24 143.247c1.619 2.616 2.638 6.333 2.638 10.472 0 4.763-1.854 8.649-3.404 11.589-.02.038-.171.125-.4.232 4.348-1.93 7.395-6.314 7.395-11.437-.001-4.653-2.512-8.704-6.229-10.856z"/>
            <path d="m106.826 154.018v.005.005c.004 5.636 3.687 10.453 8.743 12.029-.166-.062-.284-.116-.317-.152-2.351-2.528-3.915-7.04-3.915-12.185 0-4.475 1.057-8.583 3.003-11.126-4.39 1.888-7.479 6.285-7.514 11.424z"/>
            <path d="m120.175 143.118c1.244-1.046 3.553-.351 5.154 1.555 1.602 1.905 1.891 4.298.646 5.344-1.244 1.046-3.553.351-5.154-1.554s-1.891-4.298-.646-5.345z"/>
            <path d="m118.736 149.555c.455-.383 1.299-.128 1.885.568.585.696.691 1.571.236 1.954-.455.382-1.299.128-1.885-.569-.586-.696-.691-1.571-.236-1.953z"/>
        </g>
        <path d="m106.859 150.704c2.807-5.654 7.598-8.104 12.086-7.996 5.086.124 7.581 2.23 10.094 4.219 2.668 2.615 8.109 2.676 8.941-1.629-2.52 1.209-4.652 1.566-7.098-.714-2.477-1.96-5.93-4.73-11.875-4.875-6.72-.047-13.578 4.262-12.148 10.995z"
              :fill="body"/>
        <path d="m129.084 146.01c2.989 5.029 2.078 12.153-1.098 16.853 7.244-4.995 4.496-14.595 2.941-17.571z"
              :fill="body"/>
        <path d="m138.146 151.666c-1.857 1.701-3.322 2.246-6.518 1.79l-.072 3.036c2.705.001 5.664-1.125 6.59-4.826z"
              :fill="body"/>
        <path d="m111.939 136.686c6.822-2.43 16.619 1.265 22.187 4.555-7.775-8.459-18.736-8.703-22.187-4.555z"
              :fill="body"/>
        <path d="m83.865 138.197.938-1.094c4.256-5.101 10.229-8.182 17.281-10.156.847 3.812 2.207 7.319 5.219 10l1.094.969 1-1.062c7.19-7.617 15.156-14.749 33.531-13.469l.188-3c-18.3-1.274-27.568 5.893-34.75 13.281-2.094-2.334-3.148-5.191-3.781-8.844l-.281-1.594-1.562.375c-7.49 1.9-14.116 5.116-19.094 10.438-5.307-5.104-5.727-16.016-.547-23.077-5.753 1.549-11.3 18.661.764 27.233z"
              :fill="mane"/>
        <path d="m94.561 87.462c5.115-2.786 11.432-4.667 20.15-4.859 11.634-.255 23.795 3.524 36.59 12.16" fill="none"
              :stroke="mane" stroke-width="3"/>
        <path d="m78.203 123.313c-7.709-.816-13.615-4.878-16.617-10.872 10.434-4.232 16.227-11.199 22.803-17.339"
              fill="none" :stroke="mane" stroke-width="3"/>
        <path d="m159.388 102.577c3.704 6.962 2.237 15.409-.35 21.728 6.598-7.119 5.443-16.648.35-21.728z" :fill="body"/>
        <path d="m152.136 91.307c-1.328 1.211-2.668 2.806-3.938 4.562-2.54 3.514-4.803 7.644-5.781 10.938-1.83 4.351-2.547 13.952 3.156 21.625-1.645-7.336-2.192-14.323-.281-20.75.807-2.716 2.945-6.789 5.312-10.062 1.183-1.637 2.43-3.09 3.531-4.094-.975-1.141-1.044-1.295-1.999-2.219z"
              :fill="body"/>
        <path d="m89.771 113.635c-2.328-12.782-9.743-31.174-4.625-32.875 4.604-2.594 11.562 12.179 21.875 24"
              fill="none" :stroke="body" stroke-width="3"/>
        <path d="m98.24 108.072c-2.596 1.023-10.127 1.943-11.719 9.719 2.646-3.492 8.066-5.057 12.812-6.938 2.391-.956 11.515-4.452 10.344-11.75-2.23 4.476-6.797 7.13-11.437 8.969z"
              :fill="mane"/>
        <path d="m87.278 104.41c7.358-.461 10.718-2.75 12.173-9.3" fill="none" :stroke="body" stroke-width="2"/>
        <path d="m84.915 94.731c3.108-.648 7.154-1.813 8.485-7.425" fill="none" :stroke="body" stroke-width="2"/>
    </g>
    <!--
    START [LEGEND RIGHT]
    <g class="legend legend-right">
      <path clip-rule="evenodd" d="m323.871-18.994h54.008v10.502h-54.008z" fill-opacity=".8" :fill="bars" fill-rule="evenodd"/>
      <path d="m397.395-23.494h1.488v2.999h-1.488z" fill-opacity=".2" :fill="bars"/>
      <path d="m395.895-23.494h1.49v2.999h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m394.395-23.494h1.49v2.999h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m392.896-23.494h1.488v2.999h-1.488z" fill-opacity=".8" :fill="bars"/>
      <path d="m392.879-23.494h-73.508v15.002h3v-12.002h57.008v1.5 3.001 1.499h1.5v-1.499h1.5v-1.501h1.5v-1.5h1.5v-1.5h7.5z" fill-opacity=".8" :fill="bars"/>
    </g>
    END [LEGEND RIGHT]
    -->
    <!--
    START [LEGEND NONE]
    <g class="legend legend-none">
      <path clip-rule="evenodd" d="m323.871-38.496h54.008v10.501h-54.008z" fill-opacity=".8" :fill="bars" fill-rule="evenodd"/>
      <path d="m319.371-42.997v15.002h3v-12.002h57.008v12.002h3v-15.002z" fill-opacity=".8" :fill="bars"/>
    </g>
    END [LEGEND NONE]
    -->
    <!--
    START [LEGEND LEFT]
    <g class="legend legend-left">
      <path clip-rule="evenodd" d="m323.871-57.999h54.008v10.501h-54.008z" fill-opacity=".8" :fill="bars" fill-rule="evenodd"/>
      <path d="m310.389-62.499h1.49v2.999h-1.49z" fill-opacity=".2" :fill="bars"/>
      <path d="m311.889-62.499h1.49v2.999h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m313.389-62.499h1.49v2.999h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m314.889-62.499h1.49v2.999h-1.49z" fill-opacity=".8" :fill="bars"/>
      <path d="m310.367-62.5v3h6.002v1.501h1.5v1.5h1.502v1.5h1.5v1.5h1.5v-6.001h57.008v12.002h3v-15.002z" fill-opacity=".8" :fill="bars"/>
    </g>
    END [LEGEND LEFT]
    -->
    <!--
    START [HIND R 2]
    -->
    <g class="health hind leg right">
      <rect x="81.752" y="294.004" :width="54.008 * hp.legHindRight" height="10.501" fill-opacity=".8" :fill="bars" />
      <path class="frame" d="m77.252 289.504v15h3v-12h57.008v12h3v-15z" fill-opacity=".8" :fill="bars"/>
    </g>
    <!--
    END [HIND R 2]
    -->
    <!--
    START [HIND L 2]
    -->
    <g class="health hind leg left">
      <rect x="209.664" y="282.084" :width="54.008 * hp.legHindLeft" height="10.501" fill-opacity=".8" :fill="bars" />
      <path d="m190.182 277.584h1.49v3h-1.49z" fill-opacity=".2" :fill="bars"/>
      <path d="m191.682 277.584h1.49v3h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m193.182 277.584h1.49v3h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m194.682 277.584h1.49v3h-1.49z" fill-opacity=".8" :fill="bars"/>
      <path d="m196.16 277.584v3h6.002v1.5h1.5v1.5h1.502v1.5h1.5v1.5h1.5v-6h57.008v12.002h3v-15.002z" fill-opacity=".8" :fill="bars"/>
    </g>
    <!--
    END [HIND L 2]
    -->
    <!--
    START [HIND L 1]
    <g class="health hind leg left">
      <path clip-rule="evenodd" d="m208.998 271.752h54.008v10.502h-54.008z" fill-opacity=".8" :fill="bars" fill-rule="evenodd"/>
      <path d="m189.516 267.252h1.49v3h-1.49z" fill-opacity=".2" :fill="bars"/>
      <path d="m191.016 267.252h1.49v3h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m192.516 267.252h1.49v3h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m194.016 267.252h1.49v3h-1.49z" fill-opacity=".8" :fill="bars"/>
      <path d="m195.494 267.252v3h6.002v1.5h1.5v1.5h1.502v1.5h1.5v1.5h1.5v-6h57.008v12.002h3v-15.002z" fill-opacity=".8" :fill="bars"/>
    </g>
    END [HIND L 1]
    -->
    <!--
    START [HIND R 1]
    <g class="health hind leg right">
      <path clip-rule="evenodd" d="m65.126 261.254h54.008v10.502h-54.008z" fill-opacity=".8" :fill="bars" fill-rule="evenodd"/>
      <path d="m138.649 256.754h1.488v2.998h-1.488z" fill-opacity=".2" :fill="bars"/>
      <path d="m137.149 256.754h1.49v2.998h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m135.649 256.754h1.49v2.998h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m134.151 256.754h1.488v2.998h-1.488z" fill-opacity=".8" :fill="bars"/>
    </g>
    END [START HIND R 1]
    -->
    <!--
    START [FRONT R]
    -->
    <g class="health front leg right">
      <rect x="-39.874" y="251.254" :width="54.008 * hp.legFrontRight" height="10.501" fill-opacity=".8" :fill="bars" />
      <path d="m33.649 246.754h1.488v2.998h-1.488z" fill-opacity=".2" :fill="bars"/>
      <path d="m32.149 246.754h1.49v2.998h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m30.649 246.754h1.49v2.998h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m29.151 246.754h1.488v2.998h-1.488z" fill-opacity=".8" :fill="bars"/>
      <path d="m29.134 246.754h-73.508v15.002h3v-12.002h57.008v1.5 3.002 1.498h1.5v-1.498h1.5v-1.502h1.5v-1.5h1.5v-1.5h7.5z" fill-opacity=".8" :fill="bars"/>
    </g>
    <!--
    END [FRONT R]
    -->
    <!--
    START [FRONT L]
    -->
    <g class="health front leg left">
      <rect x="-79.874" y="181.254" :width="54.008 * hp.legFrontLeft" height="10.501" fill-opacity=".8" :fill="bars" />
      <path d="m-6.351 176.754h1.488v2.998h-1.488z" fill-opacity=".2" :fill="bars"/>
      <path d="m-7.851 176.754h1.49v2.998h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m-9.351 176.754h1.49v2.998h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m-10.849 176.754h1.488v2.998h-1.488z" fill-opacity=".8" :fill="bars"/>
      <path d="m-10.866 176.754h-73.508v15.002h3v-12.002h57.008v1.5 3.002 1.498h1.5v-1.498h1.5v-1.502h1.5v-1.5h1.5v-1.5h7.5z" fill-opacity=".8" :fill="bars"/>
    </g>
    <!--
    END [FRONT L]
    -->
    <!--
    START [BODY]
    -->
    <g class="health body">
      <rect x="63.252" y="158.504" :width="54.008 * hp.body" height="10.501" fill-opacity=".8" :fill="bars" />
      <path d="m58.752 154.004v15h3v-12h57.008v12h3v-15z" fill-opacity=".8" :fill="bars"/>
    </g>
    <!--
    END [BODY]
    -->
    <!--
    START [HEAD]
    -->
    <g class="health head">
      <rect x="137.998" y="70.752" :width="54.008 * hp.head" height="10.501" fill-opacity=".8" :fill="bars" />
      <path d="m118.516 66.252h1.49v2.999h-1.49z" fill-opacity=".2" :fill="bars"/>
      <path d="m120.016 66.252h1.49v2.999h-1.49z" fill-opacity=".4" :fill="bars"/>
      <path d="m121.516 66.252h1.49v2.999h-1.49z" fill-opacity=".6" :fill="bars"/>
      <path d="m123.016 66.252h1.49v2.999h-1.49z" fill-opacity=".8" :fill="bars"/>
      <path d="m124.494 66.251v3h6.002v1.501h1.5v1.5h1.502v1.5h1.5v1.5h1.5v-6.001h57.008v12.002h3v-15.002z" fill-opacity=".8" :fill="bars"/>
    </g>
    <!--
    END [HEAD]
    -->
</svg>
</template>

<script>

export default {
  name: 'StatsPony',
  props: {
    mane: {
      type: String,
      default: '#8A2BE2', // blueviolet
    },
    body: {
      type: String,
      default: '#FFD700', // gold
    },
    bars: {
      type: String,
      default: '#FF4500', // orangered
    },
    eyes: {
      type: String,
      default: '#00BFFF', // deepskyblue
    },
    white: {
      type: String,
      default: '#FFFFFF', // white
    },
    hp: {
      type: Object,
      default() {
        return {
          head: Math.random(),
          body: Math.random(),
          legFrontLeft: Math.random(),
          legFrontRight: Math.random(),
          legHindLeft: Math.random(),
          legHindRight: Math.random(),
        };
      },
    },
    faceId: {
      default: null,
      type: Number,
    },
    faceName: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      faces: [
        'cat',
        'cat-smirk',
        'happy',
        'meh-negative',
        'meh-neutral',
        'meh-positive',
        'sad',
      ],
      healthFaces: [
        'sad',
        'meh-negative',
        'meh-neutral',
        'meh-positive',
        'happy',
      ],
    };
  },
  computed: {
    averageHealth() {
      const keys = Object.keys(this.hp);
      return keys.map(key => this.hp[key]).reduce((old, current) => old + current) / keys.length;
    },
    autoFace() {
      if (this.averageHealth === 1.0) {  // wowsa
        return 'cat-smirk';
      }
      return this.healthFaces[Math.round(this.averageHealth * (this.healthFaces.length - 1))];
      // 0,1,2,3,4 = 5-1 = 4
      // 0.0*5 => 0,0 ~> 0
      // 0.5*5 => 2,5 ~> 3
      // 1.0*4 => 4,0 ~> 4
    },
    /**
     * If `faceId` is a valid index of the `faces` array, use that.
     * If `faceId` is `-1`, calculate a face based on the `hp` values.
     * If `faceName` is a valid element of the `faces` array, use that.
     * If `faceName` is `'auto'`, calculate a face based on the `hp` values.
     * Else use `'happy'`.
     *
     * @return {string}
     */
    face() {
      if (typeof this.faceId === 'number') {
        if (this.faceId >= 0 && this.faceId < this.faces.length) {
          return this.faces[this.faceId];
        }
        if (this.faceId === -1) {
          return this.autoFace;
        }
      }
      if (this.faces.indexOf(this.faceName) >= 0) {
        return this.faceName;
      }
      if (this.faceName === 'auto') {
        return this.autoFace;
      }
      return 'happy';
    },
  },
};
</script>
